<template>
  <v-list-item>
    <template #prepend>
      <v-icon icon="mdi-calendar" class="list-prepend-icon"></v-icon>
    </template>
    <template #append v-if="props.allowCancel">
      <v-dialog
        v-model="isDialogOpen"
        max-width="500"
        :persistent="isCancelling"
      >
        <template v-slot:activator="{ props: activatorProps }">
          <v-btn
            v-bind="activatorProps"
            icon="mdi-trash-can-outline"
            variant="outlined"
            color="error"
            :disabled="isCancelling"
          ></v-btn>
        </template>
        <v-card title="Class Cancel Confirmation">
          <v-card-text>
            Please confirm that you really want to cancel this class?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text="Cancel Class"
              :loading="isCancelling"
              :disabled="isCancelling"
              @click="onConfirmCancel"
            ></v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </v-list-item>
</template>

<script setup>
import { defineProps, ref } from "vue";

// cancelFunc(booking) must return a promise that settles once the booking is
// cancelled and the list is reloaded; the buttons stay locked until then.
const props = defineProps(["booking", "allowCancel", "cancelFunc"]);
const isDialogOpen = ref(false);
const isCancelling = ref(false);

function onConfirmCancel() {
  // Guard against double clicks that land before the button re-renders
  if (isCancelling.value) {
    return;
  }
  isCancelling.value = true;
  props
    .cancelFunc(props.booking)
    .catch((error) => {
      alert(error.response?.data?.detail || "Cancel failed, please try again");
    })
    .finally(() => {
      isCancelling.value = false;
      isDialogOpen.value = false;
    });
}
</script>
